/* ATLEKX | Complementarios. Event delegation supports Shopify's async recommendations. */
(function () {
  'use strict';
  if (window.__atlekxComplementaryReady) return;
  window.__atlekxComplementaryReady = true;

  function getVariants(card) {
    if (card._atlekxVariants) return card._atlekxVariants;
    var node = card.querySelector('[data-atlekx-variants]');
    try { card._atlekxVariants = JSON.parse(node.textContent); }
    catch (e) { card._atlekxVariants = []; }
    return card._atlekxVariants;
  }
  function getGroups(card) {
    var values = {};
    card.querySelectorAll('[data-atlekx-option].is-selected').forEach(function (b) {
      values[b.getAttribute('data-atlekx-option')] = b.getAttribute('data-atlekx-value');
    });
    return values;
  }
  function findVariant(card) {
    var selected = getGroups(card);
    var variants = getVariants(card);
    var positions = Object.keys(selected);
    if (!positions.length) {
      var initial = card.querySelector('[data-atlekx-initial]');
      var variantId = initial ? Number(JSON.parse(initial.textContent)) : null;
      return variants.find(function (v) { return v.id === variantId; }) || variants.find(function (v) { return v.available; }) || variants[0];
    }
    return variants.find(function (v) {
      return positions.every(function (p) { return v['option' + p] === selected[p]; });
    }) || null;
  }
  function formatMoney(cents) {
    // No utilizar theme.settings.moneyFormat: en esta tienda contiene etiquetas HTML.
    // textContent mostraba el HTML literal; Intl devuelve solo texto monetario.
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency', currency: currency, minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents) / 100);
    } catch (e) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }
  function setMessage(card, message) {
    var node = card.querySelector('[data-atlekx-message]');
    if (node) node.textContent = message || '';
  }
  function update(card, preserveMessage) {
    var variant = findVariant(card);
    var selected = getGroups(card);
    var colorPosition = card.getAttribute('data-color-position');
    var sizePosition = card.getAttribute('data-size-position');
    var colorLabel = card.querySelector('[data-atlekx-label="color"]');
    var sizeLabel = card.querySelector('[data-atlekx-label="size"]');
    if (colorLabel && selected[colorPosition]) colorLabel.textContent = selected[colorPosition];
    if (sizeLabel && selected[sizePosition]) sizeLabel.textContent = selected[sizePosition];
    var price = card.querySelector('[data-atlekx-price]');
    if (variant && price) price.textContent = formatMoney(variant.price);
    var add = card.querySelector('[data-atlekx-add]');
    if (add) {
      add.disabled = !variant || !variant.available;
      add.textContent = !variant ? 'NO DISPONIBLE' : variant.available ? 'AGREGAR' : 'AGOTADO';
    }
    if (sizePosition !== '0') {
      var variants = getVariants(card);
      card.querySelectorAll('[data-atlekx-option="' + sizePosition + '"]').forEach(function (button) {
        var value = button.getAttribute('data-atlekx-value');
        button.disabled = !variants.some(function (v) {
          return v.available && v['option' + sizePosition] === value && (colorPosition === '0' || !selected[colorPosition] || v['option' + colorPosition] === selected[colorPosition]);
        });
      });
    }
    // Variant image is updated only if the variant has its own image.
    // Products without per-size imagery keep the current color's image.
    var img = card.querySelector('.atlekx-complementary__image');
    if (img && variant && variant.featured_image && variant.featured_image.src) {
      var url = variant.featured_image.src;
      if (img.getAttribute('data-atlekx-current') !== url) {
        img.src = url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_600x$1$2');
        img.removeAttribute('srcset');
        img.setAttribute('data-atlekx-current', url);
      }
    }
    if (!preserveMessage) setMessage(card, '');
  }
  document.addEventListener('click', function (event) {
    var option = event.target.closest('.atlekx-complementary [data-atlekx-option]');
    if (option) {
      var card = option.closest('[data-atlekx-card]');
      var position = option.getAttribute('data-atlekx-option');
      card.querySelectorAll('[data-atlekx-option="' + position + '"]').forEach(function (b) {
        var selected = b === option;
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      // Si una talla no existe para el nuevo color, elegimos la primera disponible.
      if (position === card.getAttribute('data-color-position')) {
        var match = findVariant(card);
        if (!match || !match.available) {
          var chosenColor = option.getAttribute('data-atlekx-value');
          var colorPos = card.getAttribute('data-color-position');
          var sizePos = card.getAttribute('data-size-position');
          var valid = getVariants(card).find(function (v) {
            return v.available && v['option' + colorPos] === chosenColor;
          });
          if (valid && sizePos !== '0') {
            card.querySelectorAll('[data-atlekx-option="' + sizePos + '"]').forEach(function (b) {
              var active = b.getAttribute('data-atlekx-value') === valid['option' + sizePos];
              b.classList.toggle('is-selected', active);
              b.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          }
        }
      }
      update(card);
      return;
    }
    var add = event.target.closest('.atlekx-complementary [data-atlekx-add]');
    if (!add || add.disabled) return;
    var card = add.closest('[data-atlekx-card]');
    var variant = findVariant(card);
    if (!variant || !variant.available) { setMessage(card, 'Esta combinación no está disponible.'); return; }
    add.disabled = true;
    add.textContent = 'AGREGANDO…';
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: variant.id, quantity: 1}]})
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || 'No se pudo agregar el producto.');
        return payload;
      });
    }).then(function (payload) {
      // Impulse official cart refresh event.
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {product: payload.items ? payload.items[0] : payload}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:open', {bubbles: true}));
      setMessage(card, 'Agregado al carrito');
    }).catch(function (error) {
      setMessage(card, error.message || 'No se pudo agregar el producto.');
    }).finally(function () {
      update(card, true);
    });
  });
  function initialize(root) {
    (root || document).querySelectorAll('.atlekx-complementary [data-atlekx-card]').forEach(function (card) {
      if (card.dataset.atlekxInit === '1') return;
      card.dataset.atlekxInit = '1';
      var variants = getVariants(card);
      var initialNode = card.querySelector('[data-atlekx-initial]');
      var initialId = initialNode ? Number(JSON.parse(initialNode.textContent)) : null;
      var initial = variants.find(function (v) { return v.id === initialId; }) || variants[0];
      if (initial) {
        card.querySelectorAll('[data-atlekx-option]').forEach(function (button) {
          var position = Number(button.getAttribute('data-atlekx-option'));
          var active = button.getAttribute('data-atlekx-value') === initial['option' + position];
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      update(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('.atlekx-complementary')) initialize(n.parentNode); else if (n.matches && n.matches('[data-atlekx-card]')) initialize(n.closest('.atlekx-complementary') || document); else if (n.querySelector && (n.querySelector('.atlekx-complementary') || n.querySelector('[data-atlekx-card]'))) initialize(n.closest('.atlekx-complementary') || n); } }); });
  });
  observer.observe(document.documentElement, {childList:true,subtree:true});
})();
